import {React, useEffect, useState} from "react";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function CheckoutSuccessfulPage() {
  const apiKey = process.env.REACT_APP_API_KEY;
  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('session_id');
  const [userCart, setUserCart] = useState([])
  const [email, setEmail] = useState('');
  const [confirmation, setConfirmation]  = useState('')
  const [sessionData, setSessionData] = useState()


    useEffect(() => {
        //console.log("session ID exists: ", sessionId)
        if (!sessionId) window.location.href = "/";
    }, []);

    useEffect(() => {
        if(sessionId){
            fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/verify-session?session_id=${sessionId}`)
                .then(res => res.json())
                .then(data => {
                if (!data.paid) {
                    window.location.href = "/CheckoutFailedPage";
                    return;
                }
                setEmail(data.email)
                setSessionData(data)
                //console.log(data)

                window.gtag('event', 'conversion', {
                  'send_to': 'AW-18036842314/Lc9KCM2ghZAcEMq-0ZhD',
                  'transaction_id': data.transaction_id, 
                  'value': (data.amount_total / 100).toFixed(2),
                  'currency': 'USD'
                });

                
            });
        }
    }, [sessionId]);


    useEffect(() => {
        console.log((email === '' || email === null))
        console.log("herrrreeee")
        if(!email || email === '' || email === null){
            return;
        }
        else{
            console.log(email)
            handleUserOrder()
        }
    }, [email]);



    async function handleUserOrder() {
  const userCartFromStorage = localStorage.getItem("userCart");
  if (!userCartFromStorage) return alert("Cart is empty!");
  
  const cart = JSON.parse(userCartFromStorage);
  if (cart.length === 0) return alert("Cart is empty!");
  
  const confirmationNumber = generateConfirmationNumber();
  setConfirmation(confirmationNumber);
  
  const orderPromises = cart.map(item => {
    console.log(item);
    return fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/add-order`, { // Fixed: added parentheses
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        api_key: apiKey,
        pid: item.productInfo.pid,
        count: item.count,
        size: item.productInfo.size
      }),
    })
    .then(res => res.json())
    .then(data => data.oid);
  });
  
  // Wait for all orders to be inserted
  const orderIds = await Promise.all(orderPromises);
  
  const orderDate = new Date().toISOString();
  
  await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/add-userorder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      api_key: apiKey,
      email: sessionData.email, 
      OrderIDs: JSON.stringify(orderIds),
      OrderNumber: confirmationNumber,
      OrderDate: orderDate,
      status: "Pending",
      TrackingNumber: ""
    }),
  });
  
  
        const amountTotal = (sessionData.amount_total / 100).toFixed(2); // Stripe gives cents
        const paymentStatus = sessionData.payment_status;
        const email = sessionData.email;
        const transactionId = sessionData.transaction_id;
        const formatDate = new Date(orderDate).toLocaleString('en-US', { 
          dateStyle: 'medium', 
          timeStyle: 'short' 
        });

        // const subject = `Order Confirmation from Carmel House Supply`;
        const subject = `Order Confirmation #${confirmationNumber} - Carmel House Supply`;
        const message = `
<p style="font-size: 16px; line-height: 1.6; color: #333;">Thank you for your order! Your order has been successfully placed.</p>

<p style="margin-top: 20px;"><strong style="font-size: 20px; color: #333; font-weight: 600;">Confirmation Number:</strong> <span style="font-size: 24px; color: #667eea; font-weight: bold; letter-spacing: 1px; font-family: monospace;">${confirmationNumber}</span></p>

<p style="margin-top: 15px;"><strong style="font-size: 16px; color: #333;">Order Date:</strong> <span style="color: #666;">${formatDate}</span></p>

<p style="margin-top: 15px;"><strong style="font-size: 16px; color: #333;">Payment Status:</strong> <span style="color: ${paymentStatus === 'paid' ? '#27ae60' : '#e74c3c'}; font-weight: bold;">${paymentStatus}</span></p>

<p style="margin-top: 15px;"><strong style="font-size: 16px; color: #333;">Total Charged:</strong> <span style="font-size: 20px; color: #333; font-weight: bold;">$${amountTotal}</span></p>

<p style="margin-top: 15px;"><strong style="font-size: 16px; color: #333;">Transaction Number:</strong> <span style="color: #888; font-family: monospace; font-size: 14px;">${transactionId}</span></p>

<p style="margin-top: 25px; font-size: 15px; line-height: 1.6; color: #444;">We will notify you when your order is shipped. Thank you for shopping with Carmel House Supply!</p>

<p style="margin-top: 20px; font-size: 12px; color: #999;">Carmel House Supply - Your trusted supplier of quality products</p>
`;
//         const message = `
// <p>Thank you for your order! Your order has been successfully placed.</p>

// <p><strong style="font-size: 20px; color: #333;">Confirmation Number:</strong> 
// <strong style="font-size: 24px; color: #333; letter-spacing: 2px;">${confirmationNumber}</strong></p>

// <p>Order Date: ${orderDate}</p>
// <p>Payment Status: ${paymentStatus}</p>
// <p>Total Charged: $${amountTotal}</p>
// <p>Transaction Number: ${transactionId}</p>

// <p>We will notify you when your order is shipped. Thank you for shopping with Carmel House Supply!</p>

// <p style="font-size: 12px; color: #777;">
// </p>
// `;
  
  await sendEmail(email, subject, message); 
  
  //
  alert(`Order successful! Confirmation Number: ${confirmationNumber}`);
  localStorage.removeItem('userCart');
  // removed id from url to prevent adding new orders on page refresh
  window.history.replaceState({}, document.title, window.location.pathname);
}


    
//     async function handleUserOrder() {
//         const userCartFromStorage = localStorage.getItem("userCart");
//         if (!userCartFromStorage) return alert("Cart is empty!");
        
//         const cart = JSON.parse(userCartFromStorage);
//         if (cart.length === 0) return alert("Cart is empty!");
        


//         const confirmationNumber = generateConfirmationNumber();
//         setConfirmation(confirmationNumber)
//         const orderPromises = cart.map(item => {
//             console.log(item)
//             return fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/add-order`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     pid: item.productInfo.pid,
//                     count: item.count,
//                     size: item.productInfo.size
//                 }),

//             })
//             .then(res => res.json())
//             .then(data => data.oid); // return inserted order ID
//         });

//         // Wait for all orders to be inserted
//         const orderIds = await Promise.all(orderPromises);

//         const orderDate = new Date().toISOString();

//         await fetch(`${process.env.REACT_APP_API_BASE_URL}api/orders/add-userorder`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//                 email: email,
//                 OrderIDs: JSON.stringify(orderIds), // store as JSON
//                 OrderNumber: confirmationNumber,
//                 OrderDate: orderDate,
//                 status: "Pending",
//                 TrackingNumber: ""
//             }),
//         });

//         const amountTotal = (sessionData.amount_total / 100).toFixed(2); // Stripe gives cents
//         const paymentStatus = sessionData.payment_status;
//         const email = sessionData.email;

//         const subject = `Order Confirmation from Carmel House Supply`;
//         const message = `
// <p>Thank you for your order! Your order has been successfully placed.</p>

// <p><strong style="font-size: 20px; color: #333;">Confirmation Number:</strong> 
// <strong style="font-size: 24px; color: #333; letter-spacing: 2px;">${confirmationNumber}</strong></p>

// <p>Order Date: ${orderDate}</p>
// <p>Payment Status: ${paymentStatus}</p>
// <p>Total Charged: $${amountTotal}</p>

// <p>We will notify you when your order is shipped. Thank you for shopping with Carmel House Supply!</p>

// <p style="font-size: 12px; color: #777;">
// </p>
// `;
//         sendEmail(subject, message)

        
//         localStorage.removeItem('userCart');

//         alert(`Order successful! Confirmation Number: ${confirmationNumber}`);
//         // removed id from url to prevent adding new orders on page refresh
//         window.history.replaceState({}, document.title, window.location.pathname);

//     }


    function generateConfirmationNumber() {
        const length = Math.floor(Math.random() * 10) + 10; // 10–20 chars
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }


    function sendEmail(email, subject, message){
    
        const payload = {
          api_key: apiKey,
            user_email: email,
            subject: subject, //"Password Reset Confirmation",
            message: message
                
        };

        try {
            fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/sendEmail`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText}`);
                }
                return response.json();
            })
            .then((data) => {
            //console.log(data);
            //alert("Password Reset successful! You can now log in.");
            // navigate('/CustomerDashboardPage');
            })
            .catch((error) => {
                console.error("email sent failed:", error);
           //alert("email sent failed, please try again.");
            });
        } catch (error) {
            console.error("email sent failed:", error);
                //alert("email sent, please try again.");
        }

    }


//   const confirmation = urlParams.get('confirmation');

  const windowSize = useWindowSize();

  const verticalSpacer = (height) => <div style={{ height: `${height}px` }} />;
  const horizontalSpacer = (width) => <div style={{ width: `${width}px` }} />;

  

  return (
    <div>
    <div className="CartPageContainer">
      <div>
        <p style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#333333",
          textAlign: "center",
          marginBottom: "3px",
        }}>
          Payment Successful
        </p>
        {verticalSpacer(20)}
        
        <div style={{
          background: "rgba(166, 158, 158, 0.9)",
          borderRadius: 20,
          width: "90%",
          paddingTop: 30,
          paddingLeft: 20,
          paddingBottom: 30,
          paddingRight: 20,
          marginBottom: '4%',
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          {/* Success Icon */}
          <div style={{
            width: '60px',
            height: '60px',
            background: '#4CAF50',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px'
          }}>
            <svg 
              width="32" 
              height="32" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="white" 
              strokeWidth="3" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>

          <p style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "#333333",
            textAlign: "center",
            marginBottom: "10px",
          }}>
            Your payment has been successful
          </p>

          {confirmation && (
            <>
              {verticalSpacer(15)}
              <p style={{
                fontSize: "16px",
                fontWeight: "normal",
                color: "#555555",
                textAlign: "center",
                marginBottom: "5px",
              }}>
                Confirmation Number
              </p>
              <p style={{
                fontSize: "22px",
                fontWeight: "bold",
                color: "#333333",
                textAlign: "center",
                letterSpacing: "2px",
                fontFamily: "monospace",
              }}>
                {confirmation}
              </p>
            </>
          )}
        </div>

        {verticalSpacer(20)}

        <div style={{
          display: 'flex',
          justifyContent: 'center'
        }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: "#333333",
              color: "white",
              border: "none",
              borderRadius: 10,
              padding: "12px 40px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
    {verticalSpacer((windowSize.height * 0.7))}
    </div>
  );
}

export default CheckoutSuccessfulPage;